import { Draft } from "immer";
import LoyaltyUserState from "@NA/Widgets/LoyaltyRewards/LoyaltyRewardsUserState";
import { LoyaltyUserModel } from "@NA/Widgets/LoyaltyRewards/LoyaltyRewardsModel";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";

const initialState: LoyaltyUserState = {
    user: {email:"", enrollmentId:"", firstName:"", isEnrolled: false, lastName:"", status:"", userId:""},
    isLoading: true,
};

const reducer = {
    "AccountPage/GetLoyaltyUser": (draft: Draft<LoyaltyUserState>) => {
        draft.isLoading = true;
    },
    "Accountpage/DispatchCompleteLoadLoyaltyUser": (
        draft: Draft<LoyaltyUserState>,
        action: { user: LoyaltyUserModel },
    ) => {        
        draft.user = action.user;
        draft.isLoading=false;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);